import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { Faq } from 'cpie-common';
import { fetchFaq } from './FaqSlice';
import { FaqContentSelector } from './FaqContentSelector';

export function useFaq(): AbstractContentState<Faq> {
    return useCmsContent(fetchFaq, FaqContentSelector);
}
